import React from 'react';
import PropTypes from 'prop-types';

const KeyValueTile = ({ header, content, imageUrl, className }) => (
  <div className="key-value-tile__container">
    <img src={imageUrl} role="presentation" className={`${className}`} />
    <h2>{header}</h2>
    <p>{content}</p>
  </div>
);

KeyValueTile.propTypes = {
  header: PropTypes.string,
  content: PropTypes.string,
  imageUrl: PropTypes.string,
  className: PropTypes.string
};

export default KeyValueTile;



/** WEBPACK FOOTER **
 ** ./src/components/onboard/registryOnboardComponents/KeyValueTile.jsx
 **/